module.exports = __webpack_public_path__ + "f7e84805011b34f76cebc765f1a26e95.svg";